import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import TokenConfigurationPage from '../pages/Authentication/TokenConfigurationPage';
import ProtectedRouteV2 from './ProtectedRouteV2';
import RoleProtectedRoute from './RoleProtectedRoute';

const securityRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route element={<RoleProtectedRoute allowedRoles={['ADMIN', 'SUPPORT']} />}>
      <Route
        path="/auth/token-configuration"
        element={
          <>
            <PageTitle title="Configuración de token de acceso | POS System" />
            <TokenConfigurationPage />
          </>
        }
      />
    </Route>
  </Route>
);

export default securityRoutes;
